// @flow
import * as React from 'react';

type Context = {
  productId: ?number,
};

export const ProductContext: React$Context<Context> =
  React.createContext<Context>({
    productId: undefined,
  });
